export default __webpack_public_path__ + "static/media/tip.ef9be4de.jpg";